<template>
  <div id="register-layer">
    <header>
      <a href="https://www.yuanquanyun.com.cn/"><svg-icon class="logo" iconClass="logo"/>
</a>
      <!-- <span class="logo-text">电子合同服务平台</span> -->
      <span class="logo-s-title">用户注册</span>
      <a href="javascript:;" class="back-prev" @click="backStep"><返回</a>
    </header>

    <div class="register-content">
      <img :src="stepImg[step-1]" alt="">
      <div class="bar-text">
        <span>绑定手机号</span>
        <span>账号密码</span>
        <span>注册成功</span>
      </div>
      <el-form v-show="step == 1" :model="phoneForm" :rules="phoneRules" ref="phoneForm" class="phone-Form">
        <el-form-item prop="phone">
          <el-input placeholder="请输入手机号" maxlength="11" v-model="phoneForm.phone"></el-input>
        </el-form-item>
        <el-form-item prop="accountcode" style="position:relative;">
          <el-input placeholder="验证码" maxlength="4" style="width: 245px;" v-model="phoneForm.accountcode"></el-input>
          <img :src="codeImg" @click="getImgCodeHandle" class="code-img" alt="">
        </el-form-item>
        <el-form-item prop="smgcode">
          <el-input placeholder="输入验证码" maxlength="6" v-model="phoneForm.smgcode"></el-input>
          <div class="code-btn">
            <el-button type="primary" :disabled="!sendAuthCode" @click="getMsgAuthCode" v-show="sendAuthCode">获取验证码</el-button>
            <el-button type="primary" v-show="!sendAuthCode"> {{auth_time}}秒</el-button>
          </div>
        </el-form-item>
        <el-form-item style="margin-top: -10px; margin-bottom: 0;" prop="agree">
          <el-checkbox-group v-model="phoneForm.agree" style="font-size:16px; position: relative; top: 1px; color: #333;">
            <el-checkbox label="" name="agree"></el-checkbox>
            <span style="margin-left:10px; cursor:pointer;" @click="showAgreementHandle">阅读并接受《电子合同服务协议》</span>
          </el-checkbox-group>
        </el-form-item>
        <el-button type="primary" class="next" @click="registerHandle(step)">下一步</el-button>
        <router-link to="/login" class="to-login">立即登录></router-link>
      </el-form>
      <el-form v-show="step == 2" :model="accountForm" :rules="accountRules" ref="accountForm" class="account-form">
        <el-form-item prop="account">
          <!-- <div class="pin-tip">用户名：6-14位，可含数字、字母、下划线（不能纯数字/符号） </div> -->
          <el-input placeholder="用户名：6-14位可含数字、字母、下划线（不能纯数字/符号）" maxlength="14" v-model="accountForm.account"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <!-- <div class="pin-tip">密码：8-14位 由数字和字母组合（区分大小写）</div> -->
          <el-input type="password" maxlength="14" placeholder="密码：8-14位 由数字和字母组合（区分大小写）" v-model="accountForm.pass"></el-input>
        </el-form-item>
        <el-form-item prop="checkPass">
          <el-input type="password" maxlength="14" placeholder="请确认密码" v-model="accountForm.checkPass"></el-input>
        </el-form-item>
        <el-form-item prop="pin">
          <div class="pin-tip">PIN码：用于签署时身份鉴别（由6位数字组成）</div>
          <el-input type="password" placeholder="请设置PIN码" maxlength="6" v-model="accountForm.pin"></el-input>
        </el-form-item>
        <el-button type="primary" class="register" @click="registerHandle(step)">提交注册</el-button>
      </el-form>
    </div>

    <div class="mask" v-show="step == 3"></div>
    <div class="register-ok" v-show="step == 3">
      <h3>注册成功提示</h3>
      <img src="../../assets/images/register/alert-ok-img.png" class="register-ok-img" alt="">
      <p class="ok-text">恭喜您注册成功，请重新登录</p>
      <p class="ok-text"><span>{{timeout}}</span> 秒后跳转至登录页</p>
    </div>
    <e-footer></e-footer>
    <agreement ref="agreement"></agreement>
  </div>
</template>
<script>
import { getImgCodeApi, checkImageCodeApi, getsmsCodeApi, checkSmsApi } from '@/api/common'
import { registerUserApi, registerUkeyApi } from '@/api/register'
import agreement from './agreement'
import eFooter from '@/components/eFooter'
import axios from 'axios'
export default {
  components: {
    agreement,
    eFooter
  },
  data() {

    // 校验唯一
    var checkOnlyUserName = (rule, value, callback) => {
      axios.get(((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'user/checkUser', {
        params: {
          userName: value,
          phone: '',
          email: '',
          nocache: new Date().getTime()
        }
      }).then(res =>{
        if (res.data.code != '0') {
          callback(new Error(res.data.message));
        } else {
          callback();
        }
      }).catch(err => {
        callback(new Error('服务器错误！'));
      })
    }

    var checkOnlyPhone = (rule, value, callback) => {
      axios.get(((GLOBAL_CONFIG && GLOBAL_CONFIG.APP_BASE_API)? GLOBAL_CONFIG.APP_BASE_API : process.env.VUE_APP_BASE_API) + 'user/checkUser', {
        params: {
          userName: '',
          phone: value,
          email: '',
          nocache: new Date().getTime()
        }
      }).then(res =>{
        if (res.data.code != '0') {
          callback(new Error(res.data.message));
        } else {
          callback();
        }
      }).catch(err => {
        callback(new Error('服务器错误！'));
      })
    }

    // 校验手机号格式
    var checkPhone = (rule, value, callback) => {
      var phoneReg = /^1[3456789]\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error('手机号格式不正确！'));
      } else {
        callback();
      }
    }

    // 密码正则
    var passwordReg = (rule, value, callback) => {
      var pReg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,14}$/;
      if (!pReg.test(value)) {
        callback(new Error('密码格式不正确！数字字母，8-14位！'));
      } else {
        callback();
      }
    }

    // 验证密码
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.accountForm.checkPass !== '') {
          this.$refs.accountForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.accountForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    // 校验用户名
    var checkUserName = (rule, value, callback) => {
      // var userNameReg= /^[a-zA-Z][a-zA-Z0-9_]{5,13}$/;
      var reg = /^[0-9]{6,14}$/
      var userNameReg= /^[a-zA-Z0-9_]{6,14}$/;
      var reg2 = /^_{6,14}$/

      if (!userNameReg.test(value)) {
        callback(new Error('用户名格式不正确！仅允许6-14位字母数字下划线组成!'));
      }

      if (reg.test(value)) {
        callback(new Error('用户名格式不正确！不能是纯数字！'));
      }

      if (reg2.test(value)) {
        callback(new Error('用户名格式不正确！不能是纯下划线！'));
      } else {
        callback();
      }

    }

    // 校验图片验证码
    var checkImgCode = (rule, value, callback) => {
      checkImageCodeApi({
        code: value,
        id: this.imgCodeUUid
      }).then(res => {
        if (res.code !== 200) {
          callback(new Error(res.message));
        } else {
          callback();
        }
      }).catch(err => {
        callback(new Error('服务器错误！'));
      })
    }

    // 校验短信验证码
    var checkSmsCode = (rule, value, callback) => {
      checkSmsApi({
        phone: this.phoneForm.phone,
        code: this.phoneForm.smgcode
      }).then(res => {
        if (res.code !== 200) {
          callback(new Error(res.message));
        } else {
          callback();
        }
      }).catch(err => {
        callback(new Error('服务器错误！'));
      })
    }

    // 校验pin码
    var checkPin = (rule, value, callback) => {
      var pinReg = /^\d{6}\b/;
      if (!pinReg.test(value)) {
        callback(new Error('PIN码由6位数字自由组合'));
      } else {
        callback();
      }
    }

    return {
      step: 1,
      stepImg: [
        require('../../assets/images/register/bar1.png'),
        require('../../assets/images/register/bar2.png'),
        require('../../assets/images/register/bar3.png'),
      ],
      phoneForm: {
        phone: '',
        smgcode: '',
        accountcode: '',
        agree: []
      },
      phoneRules: {
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {validator: checkPhone, trigger: 'blur'},
          {validator: checkOnlyPhone, trigger: 'blur'}
        ],
        smgcode: [
          {
            required: true,
            message: '请输入短信验证码',
            trigger: 'blur'
          },
          {validator: checkSmsCode, trigger: 'blur'}
        ],
        accountcode: [{
          required: true,
          message: '请输入图片验证码',
          trigger: 'blur'
        },
        {validator: checkImgCode, trigger: 'blur'}
        ],
        agree: [
          { type: 'array', required: true, message: '请阅读并接受电子合同服务协议', trigger: 'change' }
        ]
      },
      accountForm: {
        account: '',
        pass: '',
        checkPass: '',
        pin: ''
      },
      accountRules: {
        account: [
          {
            required: true,
            message: '请设置账号',
            trigger: 'blur'
          },
          {validator: checkUserName, trigger: 'blur'},
          {validator: checkOnlyUserName, trigger: 'blur'}
        ],
        pass: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' },
          { validator: passwordReg, trigger: 'blur' }
        ],
        checkPass: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: validatePass2, trigger: 'blur' },
          { validator: passwordReg, trigger: 'blur' }
        ],
        pin: [
          { required: true, message: 'PIN码不能为空', trigger: 'blur' },
          { validator: checkPin, trigger: 'blur' }
        ]
      },
      codeImg: '',
      imgCodeUUid: '',
      sendAuthCode: true,
      auth_time: 60,
      timeout: 3
    }
  },
  created() {
    this.getImgCodeHandle()
  },
  methods: {
    getMsgAuthCode() {
      this.$refs.phoneForm.validateField('phone', error => {
        if (!error) {
          this.$refs.phoneForm.validateField('accountcode', err => {
            if (!err) {
              this.sendAuthCode = false;
              getsmsCodeApi({
                phone: this.phoneForm.phone,
                type: 'reg'
              }).then(res => {
                if (res.code !== "0") {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: 'warning'
                  });
                  this.auth_time = 60;
                  this.sendAuthCode = true;
                } else {
                  this.$message({
                    message: '短信发送成功',
                    type: 'success'
                  });
                  // 倒计时

                  this.auth_time = 60;
                  var auth_timetimer = setInterval(() => {
                    this.auth_time--;
                    if (this.auth_time <= 0) {
                      this.sendAuthCode = true;
                      clearInterval(auth_timetimer);
                    }
                  }, 1000);
                }
              }).catch(err => {
                console.log(err)
                this.$message.error('服务器错误！');
              })
            }
          })
        }
      })
    },
    getImgCodeHandle() {
      getImgCodeApi().then(res => {
        if (res.code !== "0") {
          this.$message({
            showClose: true,
            message: res.message,
            type: 'warning'
          });
        } else {
          this.codeImg = res.data.image
          this.imgCodeUUid = res.data.id
        }
      }).catch(err => {
        this.$message.error('服务器错误！');
      })
    },
    showAgreementHandle() {
      this.$refs.agreement.dialogVisible = true
    },
    registerHandle(s) {
      if (s == 1) {
        this.$refs['phoneForm'].validate((valid) => {
          if (valid) {
            this.step = 2
          } else {
            return false
          }
        })
      } else if(s == 2) {
        this.$refs['accountForm'].validate((valid) => {
          if (valid) {

            if (this.$route.query.rId) {
              registerUkeyApi({
                phone: this.phoneForm.phone,
                username: this.accountForm.account,
                password: this.accountForm.pass,
                code: this.phoneForm.smgcode,
                pin: this.accountForm.pin,
                id: this.$route.query.rId,
                sign: this.$route.query.rcontent
              }).then(res => {
                if (res.code !== 200) {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: 'warning'
                  });
                } else {
                  this.step = 3
                  this.jumpCountDown()
                }
              })
            } else {
              registerUserApi({
                phone: this.phoneForm.phone,
                username: this.accountForm.account,
                password: this.accountForm.pass,
                code: this.phoneForm.smgcode,
                pin: this.accountForm.pin
              }).then(res => {
                if (res.code !== 200) {
                  this.$message({
                    showClose: true,
                    message: res.message,
                    type: 'warning'
                  });
                } else {
                  this.step = 3
                  this.jumpCountDown()
                }
              })
            }


            // this.step = 3
          } else {
            return false
          }
        })
      }
    },
    backStep() {
      this.step--
      if (this.step < 1) {
        this.step = 1
        this.$router.push({
          path: '/register-type'
        })
      }
    },
    jumpCountDown() {
      let count_down = setInterval(() => {
        this.timeout--
        if (this.timeout <= 0) {
          this.timeout = 0
          this.$router.push('/login')
          clearInterval(count_down)
        }
      }, 1000)
    }
  }
}
</script>

<style>
  #register-layer .phone-Form input, #register-layer .account-form input {
    height: 48px;
  }
</style>
<style scoped>
  #register-layer{
    width: 100%;
    overflow: hidden;
  }

  header {
    width: 1920px;
    height: 71px;
    background: rgba(35, 43, 58, 1);
    box-shadow: 0px 2px 10px 0px rgba(4, 0, 0, 0.19);
    line-height: 71px;
    overflow: hidden;
  }

  .logo {
    margin-top: 16px;
    margin-left: 37px;
    width: 126px;
    float: left;
  }

  .logo-text {
    margin-left: 31px;
    font-size: 24px;
    color: #ffffff;
  }

  .logo-s-title{
    font-size: 24px;
    color: #ffffff;
    margin-left: 24px;
  }

  .back-prev{
    display: block;
    position: absolute;
    right: 56px;
    top: 0;
    font-size: 24px;
    color: #ffffff;
    line-height: 71px;
  }

  .register-content{
    width: 420px;
    margin: 106px auto 0;
  }

  .bar-text{
    width: 420px;
    position: relative;
    font-size: 24px;
    color: #333333;
    margin-top: 10px;
  }

  .bar-text span{
    position: absolute;
    top: 0;
  }

  .bar-text span:nth-of-type(1){
    left: -45px;
  }

  .bar-text span:nth-of-type(2){
    left: 167px;
  }

  .bar-text span:nth-of-type(3){
    left: 365px;
    width: 110px;
  }

  .phone-Form{
    margin-top: 175px
  }

  .smgcode{
    position: relative;
  }

  .code-btn{
    position: absolute;
    right: 0;
    top: 0;
  }

  .code-btn button{
    height: 48px;
  }

  .next{
    margin-top: 54px;
    width: 100%;
    height: 50px;
    font-size: 18px;
  }

  .to-login{
    font-size: 18px;
    color: #E85052;
    text-align: right;
    margin-top: 31px;
    width: 100%;
    display: block;
  }

  .account-form{
    margin-top: 108px;
  }

  .register{
    margin-top: 87px;
    width: 100%;
    height: 50px;
    font-size: 18px;
    font-weight: 400;
    font-family:Microsoft YaHei;
  }

  .mask{
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, .4);
    left: 0;
    top: 0;
    position: fixed;
  }

  .register-ok{
    width:434px;
    height:268px;
    background:rgba(255,255,255,1);
    border-radius:10px;
    position: fixed;
    left: 50%;
    top: 50%;
    margin: -134px -217px;
  }

  .register-ok h3{
    text-align: center;
    line-height: 73px;
    color: #333333;
    font-size: 18px;
    font-weight: normal;
  }

  .register-ok img{
    display: block;
    width: 130px;
    margin: 20px auto 10px;
  }

  .register-ok .ok-text{
    text-align: center;
    color: #666666;
    font-size: 14px;
    margin-bottom: 5px;
  }

  .ok-text span{
    color: #E85052;
  }

  .code-img{
    display: block;
    width: 150px;
    height: 48px;
    position: absolute;
    right: 0;
    top: 0;
  }

  .pin-tip{
    line-height: 20px;
    margin-top: 0px;
    color: #F56C6C;
    margin-bottom: 10px;
  }
</style>
